<h1 class="colorSearch" mat-dialog-title>Esegui aggiornamento stato</h1>
<div mat-dialog-header *ngIf="this.fromElencoInterventi" align="center">
  <p><b>La motivazione sarà valida per <br> tutti gli interventi selezionati</b></p>
</div>
<div mat-dialog-content>

  <div class="flex-row" *ngIf="!isRimodulazione">
    <mat-form-field appearance="fill" color='accent' class="searchbar">
      <mat-label class="purp">Motivazione {{ this.operazioneDaEffettuare }}</mat-label>
      <textarea matInput [(ngModel)]="motivazioneIntervento"></textarea>
    </mat-form-field>
  </div>

  <div class="flex-column" *ngIf="isRimodulazione" [formGroup]="form">

    <mat-form-field appearance="fill" color='accent' class='searchbar'>
      <mat-label class="purp">Tipo rimodulazione</mat-label>
      <mat-select [formControlName]="'tipologiaRimodulazione'">
        <mat-option *ngFor="let tip of tipologiaRimodulazione" [value]="tip.idTpRimodulazione">
          {{tip.descrTpRimodulazione}}</mat-option>
      </mat-select>
      <mat-error
        *ngIf="this.form.controls.tipologiaRimodulazione.errors && this.form.controls.tipologiaRimodulazione.touched">
        <mat-error *ngIf="this.form.controls.tipologiaRimodulazione.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="fill" color='accent' class='searchbar'>
      <mat-label class="purp">Nuovo importo finanziato</mat-label>
      <input type="number" matInput [formControlName]="'nuovoImporto'">
      <mat-error *ngIf="this.form.controls.nuovoImporto.errors && this.form.controls.nuovoImporto.touched">
        <mat-error *ngIf="this.form.controls.nuovoImporto.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="fill" color='accent' class="searchbar">
      <mat-label class="purp">Descrizione Rimodulazione</mat-label>
      <textarea matInput [formControlName]="'descrizioneRimodulazione'"></textarea>
      <mat-error
        *ngIf="this.form.controls.descrizioneRimodulazione.errors && this.form.controls.descrizioneRimodulazione.touched">
        <mat-error *ngIf="this.form.controls.descrizioneRimodulazione.errors.required">Campo obbligatorio
        </mat-error>

      </mat-error>
    </mat-form-field>


  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button color='accent' class='persBtn' [mat-dialog-close]="false">
    <p class='cont'>ANNULLA</p>
  </button>
  <button *ngIf="!isRimodulazione" mat-raised-button color='accent' class='persBtn' (click)="confirmOperazione()">
    <p class='cont'>ESEGUI</p>
  </button>
  <button *ngIf="isRimodulazione" mat-raised-button color='accent' class='persBtn' (click)="confirmRimodulazione()">
    <p class='cont'>ESEGUI</p>
  </button>
</div>
